import React from 'react';
import {
	List,
	Filter,
	TextInput,
	Datagrid,
	TextField,
	BooleanField,
	NumberField,
	FunctionField,
	TopToolbar,
	CreateButton,
} from 'react-admin';
import ConfirmDeleteButton from '../../Components/Button/ConfirmDeleteBtn';
import SyncFromStripeButton from '../../Components/Button/SyncFromStripeButton';

const PlanFilter = (props: any) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
	</Filter>
);

const ListActions = () => (
	<TopToolbar>
		<CreateButton />
		<SyncFromStripeButton />
	</TopToolbar>
);

export const PlanList = (props: any) => (
	<List {...props} filters={<PlanFilter />} exporter={false} actions={<ListActions />}>
		<Datagrid rowClick={(id) => `${id}`}>
			<TextField source="id" />
			<TextField source="slug" />
			<TextField source="name" />
			<TextField source="stripeProductId" label="Stripe Product" />
			<NumberField source="position" sortable={true} />
			<BooleanField source="enabled" />
			<FunctionField
				render={(record: any) => (
					<ConfirmDeleteButton
						record={record}
						title="Delete plan"
						entity="plans"
						description="Are you sure to delete this plan?"
						confirmMessage="Plan deleted"
					/>
				)}
			/>
		</Datagrid>
	</List>
);
